import { DataGridPro } from '@mui/x-data-grid-pro';
import {
  PrintPage,
  GridPdfWrapper,
  PdfLeftGrid,
  PdfTitleTypography,
  GridHeading,
} from '../ui/styled';
import { getAscendingSort, getRandomId, rowEvenOdd } from '../common/commonUtils/commonUtils';
import { calOmsActPleaseReadText } from '../../constants';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const calomsactPdfDataGrid = (
  groupedData,
  authorizationReportsCalomsac,
  columnsData
) =>
  Object.keys(groupedData).map((key) => {
    const groupItems = groupedData[key];
    //console.log(groupItems)
    //for (var item of groupItems)
      //console.log(item.prtKey + ' - admit: ' + item.sapAthAdmDate + ', caid: ' + item.caid + ' - discharge: ' + item.sapAthDchDate + ', cdid: ' + item.cdid)
    return (
      <div key={key}>      
      <Box key="key" display="flex"
        alignItems="center" m={4} key={key}>
        <GridPdfWrapper>
          <GridHeading container>
            <Typography variant="h6">
              WestCare of Califonia STOP Area {STOP_REGION === '1' ? 'I' : 'III'}
            </Typography>
            <Typography variant="h5">
              CalOms Admit and Discharge Report
            </Typography>
          </GridHeading>
          <Grid container>
            <Typography variant="h6">{calOmsActPleaseReadText}</Typography>
          </Grid>
          <Grid container>
            <Grid item sm={12} md={6}>
              <PdfTitleTypography variant="h4">
                {groupItems[0]?.cboName} {key}
              </PdfTitleTypography>
            </Grid>
            <PdfLeftGrid item sm={12} md={6}>
              <Typography variant="h6">
                Admin Contact: {groupItems[0]?.admCntName}
              </Typography>
              <Typography variant="h6">
                Fax: Ph: {groupItems[0]?.admPhone}
              </Typography>
              <Typography variant="h6">
                CalOMS Contact: {groupItems[0]?.cntName}
              </Typography>
              <Typography variant="h6">
                Fax: {groupItems[0]?.cntFax} Ph: {groupItems[0]?.cntPhone}
              </Typography>
            </PdfLeftGrid>
          </Grid>
          <DataGridPro
            autoHeight
            getRowHeight={() => 'auto'}
            columns={columnsData}
            rows={groupItems}
            getRowId={() => getRandomId()}
            getRowClassName={(params) =>
              rowEvenOdd(params.indexRelativeToCurrentPage)
            }
            loading={authorizationReportsCalomsac.isLoading}
            initialState={getAscendingSort('cboName')} 
          />
        </GridPdfWrapper>
      </Box>
      <div className="page-break-after" />
      </div>
    );
  });
